module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), (_vm.client && _vm.client.id) ? _c('v-toolbar', {
    attrs: {
      "color": _vm.themeColor,
      "dense": "",
      "dark": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("\n      " + _vm._s(_vm.userObject.first_name) + " " + _vm._s(_vm.userObject.last_name) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading",
    class: _vm.headingClasses
  }, [_c('v-text-field', {
    attrs: {
      "name": "appointment-title",
      "required": "",
      "rules": [function (v) { return !!v || 'Title is required'; }],
      "label": "Please choose a title for your note"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.choosedate = true
      }
    }
  }, [_c('v-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v("\n      " + _vm._s(_vm.dateformat(_vm.noteDate)) + "\n    ")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "290"
    },
    model: {
      value: (_vm.choosedate),
      callback: function($$v) {
        _vm.choosedate = $$v
      },
      expression: "choosedate"
    }
  }, [_c('v-card', [_c('v-date-picker', {
    model: {
      value: (_vm.noteDate),
      callback: function($$v) {
        _vm.noteDate = $$v
      },
      expression: "noteDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (!_vm.isNewNote) ? _c('v-card-text', {
    attrs: {
      "row": ""
    }
  }, [_c('server-errors', {
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "box": "",
      "auto-grow": "",
      "name": "appointment-notes",
      "required": "",
      "append-icon": "notes",
      "label": "Optionally write more notes here",
      "multi-line": ""
    },
    on: {
      "click:append": _vm.addTemplate
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), (_vm.id && _vm.id > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('document-list', {
    attrs: {
      "note-id": _vm.id,
      "value": _vm.documents
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('space-picker', {
    attrs: {
      "label": "Share this note",
      "with-select": false,
      "attrs": {
        hint: _vm.sharingHint,
        persistentHint: true
      }
    },
    model: {
      value: (_vm.sharing),
      callback: function($$v) {
        _vm.sharing = $$v
      },
      expression: "sharing"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    staticClass: "px-3"
  }, [(_vm.id) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = true
      }
    }
  }, [_vm._v("\n      Delete\n    ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "290"
    },
    model: {
      value: (_vm.confirmDelete),
      callback: function($$v) {
        _vm.confirmDelete = $$v
      },
      expression: "confirmDelete"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("Are you sure you want to delete this note?")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error",
      "loading": _vm.delRequest.loading
    },
    on: {
      "click": _vm.doDelete
    }
  }, [_vm._v("Yes. Delete it")])], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.dirty,
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !(_vm.dirty) || !(_vm.valid),
      "color": "primary",
      "loading": _vm.saveRequest.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.saveText) + "\n    ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.appointmentId) ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-avatar', {
    staticClass: "teal"
  }, [_c('v-icon', {
    attrs: {
      "color": "white darken-4",
      "small": ""
    }
  }, [_vm._v("event")])], 1), _vm._v("\n      " + _vm._s(_vm.appointment.title || _vm.appointment.full_name) + "\n      " + _vm._s(_vm.dateformat(_vm.appointment.start_time)) + "\n    ")], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d87c5aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/edit/Notes.vue
// module id = 1369
// module chunks = 9